function capitalize(text: string) {
    const parts = text.split('_');
    let name = '';
    for (const part of parts) {
        name += part.charAt(0).toUpperCase() + part.slice(1) + ' ';
    }
    return name;
}

export const text = {
    capitalize,
};